import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { styled } from "styled-components";
import { Carousel, Tooltip } from "antd";
import dayjs from "dayjs";
import { keyframes } from "styled-components";

export async function getReview() {
  const response = await axios.get("/homepageReview?vetIdx=11");
  return response.data;
}

function Review() {
  const [windowWidth, setWindowWidth] = useState();

  const [dataList, setDataList] = useState([]);
  const [slidesToShow, setSlidesToShow] = useState(3); // 캐러셀 초기 슬라이더 갯수 설정

  const [animate, setAnimate] = useState(false);
  const componentRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      let review_data = [
        {
            "idx": 20,
            "vetIdx": 11,
            "nickname": "곽두팔35",
            "imgUrl": null,
            "content": "방에 떨어진 은행을 주워먹어서\n급히 다녀왔는데\n의사선생님도,간호사선생님도\n모두모두 너무 친절하세요~~~",
            "regDate": "2024-02-25"
        },
        {
            "idx": 37,
            "vetIdx": 11,
            "nickname": "코코햅삐",
            "imgUrl": null,
            "content": "병원 내부도 깔끔하고 담당 선생님도 친절하시고 꼼꼼한진료 너무 감사합니다:) 주변에 24시간 동물병원이 있다는게 마음이 놓이네요 ^^",
            "regDate": "2023-04-02"
        },
        {
            "idx": 30,
            "vetIdx": 11,
            "nickname": "유부심짱",
            "imgUrl": null,
            "content": "저희 레몬이가 사료를 과다복용해 방문하게 되었습니다.\n처음있는일이라 너무 놀랐는데 친절하게 잘 응대해주셨어요 ㅠㅠ\n뱃속에 사료가 가득해서 엄청 놀랐는데 다행이 폭풍응가하더니 빠른속도로 회복했습니다.\n약복투에 귀여운 그림도 너무 감사합니다💗",
            "regDate": "2023-08-28"
        },
        {
            "idx": 44,
            "vetIdx": 11,
            "nickname": "뿌띠코",
            "imgUrl": null,
            "content": "보미원장님이랑 백원장님 넘좋으세요\n늘 친절하시구 꼼꼼하게말씀해주셔서 멀어도 항상 여기로와요!!",
            "regDate": "2022-08-13"
        },
        {
            "idx": 46,
            "vetIdx": 11,
            "nickname": "토끼백성36",
            "imgUrl": null,
            "content": "둘째 발 다쳤을 때 진료해주신 평일오후 여 선생님도 친절했고 첫째 건강검진 해주신 주말 야간 남 선생님도 너무 친절했어요! 아이들이 아픈걸 고려해 24시 병원 가까운곳으로 이사왔는데 잘했다는 생각이 드네요",
            "regDate": "2022-07-24"
        },
        {
            "idx": 23,
            "vetIdx": 11,
            "nickname": "Kangg",
            "imgUrl": null,
            "content": "이것저것 추가없이 필요한 검사만 할수있고 남녀원장님 모두 과잉진료없이 보호자선택에 맡겨서 좋아요 테크니션분들도 친절합니다",
            "regDate": "2023-12-03"
        },
        {
            "idx": 49,
            "vetIdx": 11,
            "nickname": "aa7****",
            "imgUrl": null,
            "content": "안녕하세요 24동물메디컬센터에서 어제 우리댕댕이꼬맹이애기가 방광결석때문에 수술을햇어요\n병원방문에서접수부터 의사선생님과상담진료까지 그러고수술까지 진행후 오늘이틀째입원중인 우리집댕댕이애기가 여러선생님들이고생들하시는덕에 차츰잘호전중이랍니다 저는인터넷보고제가직접찾아가서 진료후수술를진행하엿는데요 병원들어서서접수할때부터 저는좋터라구요 제가걱정할때마다 힘들고바쁜와중에도 공감해주려하시는맴들이 더좋앗고요 집에와걱정하고잇는보호자에게 애기체크해서 전화로알려주시기도하고 사진도 찍어보내주시고보호자맴과동물들맴들을 이리잘공감해주는 24시동물메디컬센터 제가고민하고찾은 동물병원중 젤로 좋아요 내일또 우리댕댕이보러 고고고고고 잘부탁드립니다 아아아아아 여러선생님들 감사합니다 🙏",
            "regDate": "2022-04-29"
        },
        {
            "idx": 35,
            "vetIdx": 11,
            "nickname": "밍쯔sz",
            "imgUrl": null,
            "content": "울 둥이 치아가 많이 안좋아서 가까운 지역으로 스케일링 예약 잡아놓은 상태였는데,\n스케일링 3일 전 잇몸에서 가까이 피가 엄청 나서 급하게 예약 취소 하고 큰 병원인 스카이로 방문했어요\n전에도 울 흰둥이 호흡곤란때문에 응급으로 방문했을때 넘 친절하게 보살펴주셔서 가장 먼저 생각난곳이 스카이였답니다 :)\n역시나 치아가 많이 안좋아서 스케일링으로 예약 잡았구요 모두들 너무 친절하십니다",
            "regDate": "2023-05-13"
        },
        {
            "idx": 33,
            "vetIdx": 11,
            "nickname": "hoh****",
            "imgUrl": null,
            "content": "저희 냥이 당뇨도 완치했고 최근에는 종양제거 수술도 무사히 마쳤어요~\n나이가 많아 걱정했는데 주치의 선생님께서 꼼꼼하게 챙겨주시고 연락해서 설명해주시고, 다른 선생님들, 테크니션 선생님들 모두 친절하세요. 기다리는 시간이 조금 길기는 하지만 아이가 나으면 그게 대수인가요~ 비용 관련해서 말이 많은데 저희 아이가 받을 수 있는 치료나 서비스, 관리인력 등 고려하면 부담하지 못할 정도는 아닌 것 같습니다!\n저희 호야 이뻐해주셔서 감사드려요~\n\n붕대는 제가 감아뒀어요..^^ 병원 선생님들은 엄청 잘 감아주셨어요 ㅎㅎ",
            "regDate": "2023-07-03"
        },
        {
            "idx": 39,
            "vetIdx": 11,
            "nickname": "포비의꿈",
            "imgUrl": null,
            "content": "13살아들 주말에 캠핑가서 모래먹고\n설사해서 일욜날 밤에 급하게 갔는데\n여자원장님께서 친절하게 잘 봐주셔서\nct찍고 피아수액맞고 약처방받고\n일주일 약먹고 아들 쌩쌩해졌네요😄\n감사합니당 👍👍",
            "regDate": "2023-02-12"
        },
        {
            "idx": 19,
            "vetIdx": 11,
            "nickname": "\bdud****",
            "imgUrl": null,
            "content": "3년동안 저희 곰이 케어해주시고 살려주신 윤혜진 선생님 정말 감사했습니다.\n선생님을 만나서 아이가 다른 뇌수막염 진단받은 강아지들보다 더 오래 제 곁에 있다갈 수 있었던것같습니다.\n재발하고 처음 만나서부터 곰이 무지개다리 건너는날까지 끝까지 함께 해주셔서 정말 고맙습니다.\n저희 곰이 돌봐주신 다른 선생님들께도 감사드립니다.\n그리고 입원해있을때 저 예쁜사진 찍어주신 선생님 누구신지몰라도 너무 감사합니다\n이제 병원에 갈 일이 없지만 리뷰보고 병원찾으시는분들이 있다면 저는 추천드리고싶습니다. 돈을 정말 많이 썻지만 전혀 아깝지않았고 후회없었습니다.",
            "regDate": "2024-03-04"
        },
        {
            "idx": 24,
            "vetIdx": 11,
            "nickname": "세상에 모든 고양이가 행복하기를",
            "imgUrl": null,
            "content": "가은 선생님 저희 고양이 진료 잘 봐주셔서 감사합니다. 고양이를 대하는 마음이 따뜻한 수의사 시네요~!💖😺💖",
            "regDate": "2023-12-02"
        },
        {
            "idx": 48,
            "vetIdx": 11,
            "nickname": "뚜픽스",
            "imgUrl": null,
            "content": "강아지 다쳐서 갔는데 진찰도 꼼꼼히 잘 봐주시고 설명도 잘해주세요!! 그리고 처방도 잘해주셨는지 강아지도 많이 좋아져서 지금은 생활 잘하고 있어요!!",
            "regDate": "2022-07-03"
        },
        {
            "idx": 32,
            "vetIdx": 11,
            "nickname": "뿌티코",
            "imgUrl": null,
            "content": "주기적으로 애기검진하러갑니다!!\n집근처에 동물병원이 많이있는편인데\n백원장님이 제일 잘봐주시는것같아서\n일부러 30분차타고 갑니다\n다른분들 자주바뀌시는것같은데 백원장님이랑 윤보미원장님..?\n두분은 꼭 계셨으면좋겠어요🥹😍",
            "regDate": "2023-07-13"
        },
        {
            "idx": 26,
            "vetIdx": 11,
            "nickname": "한다2617",
            "imgUrl": null,
            "content": "점심만 해도 없던 사진의 상처가 있어서 너무 놀라서 병원 찾아봤어요\n리뷰가 좋은 곳은 다 야간진료를 안 하고 24시 하는 동물병원은 특히 고양이 진료 잘 보는 곳이 없다하여 걱정이었는데\n고양이 세마리 키우는 집사언니가 추천해준 곳이라 왔습니다 2번 진료실에서 봐주신 갈색눈 남자 의사선생님 정말 친절합니다\n진료 후 급하지 않게, 천천히 설명해주셔서 정말 감사합니다 간지러워서 긁어서 생긴 상처인 것 같다고 하시고 귓속에 곰팡이균이 많대요.. 앞으로 귀 청소 잘해주고 병원도 꼬박꼬박 잘 데리고 다녀야겠습니다 그냥 건강한 아이인 줄 알고 미리 케어 못해준 게 너무나 미안하고 후회되는데 지금부터라도 더 잘 관리해드려야겠다고 다짐했어요\n참고로 넥카라 사진은 울 냥이 아가때에요",
            "regDate": "2023-10-24"
        },
        {
            "idx": 25,
            "vetIdx": 11,
            "nickname": "kj****",
            "imgUrl": null,
            "content": "우리집 냥이가 당뇨가 있어서 사료를 병원에서밖에 못사는데 24시간이라 밤에 사료가 떨어져도 갈 수 있어서 좋아요👍👍👍",
            "regDate": "2023-11-19"
        },
        {
            "idx": 42,
            "vetIdx": 11,
            "nickname": "gks****",
            "imgUrl": null,
            "content": "다른 24시 대형병원에서 5일간입원치료를 해도 아이상태가 전여 호전되지않고 돈만 까먹다가 여기 스카이동물병원으로 옴겼는데 오형서 과장님께 상담받고 입원치료한지 이틀만에 아주 많이 호전되서 약이랑 피아수액 처방받고 퇴원해서 집에서 몇일 캐어하니 완전한 컨디션으로 돌아왔습니다.. 첨에 아이가 상태가 금방이라도 잘못될것처럼 안좋아서 집에서 가장가까운 병원으로 갔다가 생돈만 날렸는데 첨부터 여기로 왔으면 돈도 훨신덜들고 아이도 고생덜했을텐데... 오형서 과장님 설명도 새새히 잘해주시고 보호자 입장에서 많이 배려해주시고 치료도 잘해주셔서 너무 감사합니다.\n대형 병원이다보니 동내병원보다 싸다고는 못하겠지만 치료는 확실합니다 어설프게 동내병원에서 고생하는것보단 스카이병원 적극 추천합니다",
            "regDate": "2022-11-30"
        },
        {
            "idx": 43,
            "vetIdx": 11,
            "nickname": "류채윤",
            "imgUrl": null,
            "content": "광주sky메디컬센터 추천해요. 특히 봄이수술 담당해주신 이승언 외과과장님 너무 추천합니다.🙏😀\n얼마전 애견카페서 골절사고를 겪은 뒤 이승언 과장님이 수술당당해주셨는데 수술이 넘넘 잘 끝났고 그 덕분에 빠르게 회복이 되었어요. 지금은 무사히 잘 걸어다닙니다. 이사를 와서 병원을 옮기긴 했는데 그 병원 원장님도 xray보더니 너무 수술 잘되었다고 하시더라구요 :)\n당시 사고로 허둥지둥 했었던 저를 차분히 안심시켜주시고 뛰어난 실력으로 수술도 잘해주셔서 그 감사함을 잊지 않고 있습니다.\n담에 광주 출장 가면 찾아뵐게요. 감사합니다 ^^",
            "regDate": "2022-10-19"
        },
        {
            "idx": 28,
            "vetIdx": 11,
            "nickname": "하루아키90",
            "imgUrl": null,
            "content": "야간 진료 봐주시는 윤승현쌤?넘 감사합니다\n여러병원 다녀도 못찾은 원인때문에 맘고생 심하게 했는데요 증상 들으시더니 바로 발견하시더라구요\n거기다 타병원에서 가져온 여러검사지들도 꼼꼼히 봐주시고 실력면에서 넘 믿음이 가서 한시름 놨습니다 약 처방하실때도 아이에게 무리가지 않게 이것저것 신경써주셔서 정말 넘넘 감사드려요 직장때문에 야간진료 주로 보게 되는데 쌤이 계셔서 넘 안심이 됩니다 부디 오래오래 우리 아이 주치의 되주시면 좋겠어요 넘 감사한 맘에 이렇게라도 리뷰남깁니다 정말 고맙습니다",
            "regDate": "2023-10-01"
        },
        {
            "idx": 40,
            "vetIdx": 11,
            "nickname": "오드리7192",
            "imgUrl": null,
            "content": "첫방문 했어요.\n접수 직원분들도 친절하시고, 김보미 원장님도 차분하게 설명 잘해주셨어요. 병원이 크고 깔끔해서 좋고,다만 주차장이 협소하여 아쉬웠습니다.",
            "regDate": "2023-02-04"
        }
      ];
      setDataList(review_data);
      // try {
      //   // API 호출
      //   const res = await getReview();
      //   // 데이터 받아오면 상태 업데이트
      //   if (res.result === "ok") {
      //     setDataList(res.data);
      //     console.log(res.data);
      //   } else console.log(res.result);
      // } catch (error) {
      //   console.error("Error fetching review data:", error);
      // }
    };

    fetchData(); // 함수 호출
  }, []); // 빈 배열은 컴포넌트가 마운트될 때 한 번만 실행

  useEffect(() => {
    const handleScroll = () => {
      // 예시: 화면의 중간에 도달했을 때 애니메이션을 실행하려면
      // const midScreen = window.innerHeight * 5.5;
      const componentTop = componentRef.current.getBoundingClientRect().top;

      // console.log('innerHeight : ', window.innerHeight);
      // console.log('scrollY : ', window.scrollY);
      // console.log('midScreen : ', midScreen);
      if (componentTop < window.innerHeight) {
        setAnimate(true);
      }
      // else {
      //   setAnimate(false);
      // }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      // 컴포넌트 언마운트 시 이벤트 리스너 제거
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setWindowWidth(window.innerWidth);

    const handleResize = () => {
      setWindowWidth(window.innerWidth);

      // 화면 크기에 따라 slidesToShow 값을 동적으로 변경
      if (window.innerWidth < 576) {
        setSlidesToShow(1);
      } else if (window.innerWidth < 768) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    // 컴포넌트 마운트 시 초기 값 설정
    handleResize();

    // 창 크기가 변경될 때마다 이벤트 리스너 등록
    window.addEventListener("resize", handleResize);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  };

  const maskedNickname = (nickname) =>
    nickname.substring(0, 2) + "*".repeat(nickname.length - 2);

  return (
    <>
      <Container>
        <TextWrapper ref={componentRef}>
          <div className={animate ? "animate" : ""}>
            <p style={{ margin: 0 }}>Review</p>
            <h2 style={{ margin: 0, marginBottom: "16px" }}>
              <strong>리/얼/후/기</strong>
            </h2>
          </div>
        </TextWrapper>
        <CarouselContainer>
          <StyledCarousel
            slidesToShow={slidesToShow}
            autoplay={true}
            autoplaySpeed={5000}
            dots={false}
            // dotPosition="bottom"
          >
            {dataList.map((item, index) => (
              <div key={item.idx}>
                <div
                  style={{
                    margin: "5px 20px",
                    boxSizing: "border-box",
                  }}
                >
                  {slidesToShow === 2 ? (
                    <Tooltip
                      title={item.content}
                      overlayStyle={{
                        letterSpacing: "1px",
                        lineHeight: "1.5",
                        maxWidth: "400px",
                      }}
                      overlayInnerStyle={{
                        // backgroundColor: "whitesmoke",
                        // color: "#000",
                        padding: "10px 20px",
                      }}
                    >
                      <div
                        style={{
                          minHeight: "300px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          textAlign: "center",
                          padding: "20px",
                          borderRadius: "20px",
                          boxShadow: "0 4px 8px rgb(0,0,0,0.2)",
                          // border: "1px solid #ccc",
                          // backgroundColor: "#e2edf6",
                        }}
                      >
                        <div>
                          <p className="name">
                            {maskedNickname(item.nickname)}님의 리뷰
                          </p>
                          <p className="content">
                            {dayjs(item.regDate).format("YYYY.MM")}
                          </p>
                          <p className="content">
                            {windowWidth < 576 || windowWidth > 768
                              ? item.content
                              : truncateText(item.content, 100)}
                          </p>
                        </div>
                      </div>
                    </Tooltip>
                  ) : (
                    <div
                      style={{
                        minHeight: "300px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        textAlign: "center",
                        padding: "20px",
                        borderRadius: "20px",
                        boxShadow: "0 4px 8px rgb(0,0,0,0.2)",
                        // border: "1px solid #ccc",
                        // backgroundColor: "#e2edf6",
                      }}
                    >
                      <div>
                        <p className="name">
                          {maskedNickname(item.nickname)}님의 리뷰
                        </p>
                        <p className="content">
                          {dayjs(item.regDate).format("YYYY.MM")}
                        </p>
                        <p className="content">
                          {slidesToShow === 2
                            ? truncateText(item.content, 100)
                            : item.content}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </StyledCarousel>
        </CarouselContainer>
      </Container>
    </>
  );
}

const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%; /* 가로 폭 100%로 설정 */
  padding: 5rem 1rem;
  /* margin: 50px 42px 60px 42px; */
  /* background-color: whitesmoke; */
  & .name {
    font-size: 1.2rem;
    font-weight: 700;
  }
`;

const CarouselContainer = styled.div`
  width: 100%;
`;

const StyledCarousel = styled(Carousel)`
  .slick-dots {
    padding: 0; /* 기존 패딩 초기화 */
    list-style: none; /* 리스트 스타일 제거 */

    li {
      margin-right: 8px; /* 도트 간 여백 조절 */
      button {
        margin-top: 40px; /* 기존 마진 초기화 */
        width: 8px; /* 도트 크기 조절 */
        height: 8px;
        border-radius: 50%; /* 도트를 원 모양으로 만들기 */
      }
    }
  }
`;

const TitleWrapper = styled.div`
  width: 80%;
  height: fit-content;
  @media screen and (max-width: 690px) {
    padding-bottom: 2rem;
  }
  padding-bottom: 4rem;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h2 {
      color: #000048;
      font-size: 3rem;
      margin: 0;
    }
    p {
      color: #000048;
      margin: 5px;
    }
  }
`;

const slideDown = keyframes`
    from {
        transform: translate(0, -50%);
        opacity: 0;
    }
    to {
        transform: translate(0,0);
        opacity: 1;
    }
`;

const TextWrapper = styled.div`
  width: 100%;
  height: 20%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  color: #403631;

  @media screen and (max-width: 500px) {
    justify-content: center;
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h2 {
      font-size: 2.5rem;
      font-weight: normal;
      @media screen and (max-width: 690px) {
        font-size: 2rem;
      }
    }
    p {
      font-weight: bold;
      font-size: 0.9rem;
      opacity: 0.6;
    }
  }

  .animate {
    animation: ${slideDown} 4s ease;
  }
`;

export default Review;
